import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ButtonProps, Group, Text, useMantineTheme } from '@mantine/core'
import { Anchor, Icon } from '@/components/Elements'

interface IProps extends ButtonProps {
  children?: React.ReactNode
  onBack?: (event: React.MouseEvent<HTMLElement>) => void
  title?: string
}

export const BackButton: React.FC<IProps> = ({ children, onBack, title, ...props }) => {
  const { t } = useTranslation()

  const theme = useMantineTheme()

  const dark = theme.colorScheme === 'dark'

  const navigate = useNavigate()

  const handleBack = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()

    if (onBack) {
      onBack(event)
    } else {
      navigate(-1)
    }
  }

  title = title || t('back')

  return (
    <Anchor
      onClick={handleBack}
      truncate
      className={'whitespace-nowrap'}
      color={dark ? theme.colors.dark[0] : theme.colors.gray[7]}
    >
      {children || (
        <Group spacing={'xs'} noWrap>
          <Icon name={'chevron-left'} />

          <Text weight={600}>{title}</Text>
        </Group>
      )}
    </Anchor>
  )
}
